import React from "react";
import "./App.css";
import TextCounter from "./TextCounter";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <TextCounter />
      </header>
    </div>
  );
}

export default App;
